<script>
import WootReports from './components/WootReports.vue';
import AgentsInboxesReports from './AgentsInboxesReports.vue';

export default {
  components: {
    WootReports,
    AgentsInboxesReports,
  },
  data() {
    return {
      selectedTabIndex: 0,
    };
  },
  computed: {
    tabs() {
      return [
        {
          key: 'performance',
          name: this.$t('AGENT_REPORTS.TABS.PERFORMANCE'),
        },
        {
          key: 'agents_inboxes',
          name: this.$t('AGENTS_INBOXES_REPORTS.HEADER'),
        },
      ];
    },
  },
  methods: {
    onTabChange(index) {
      this.selectedTabIndex = index;
    },
  },
};
</script>

<template>
  <div class="flex flex-col flex-1 min-h-0">
    <woot-tabs
      class="font-medium [&_.tabs]:p-0 px-4 pt-4"
      :index="selectedTabIndex"
      @change="onTabChange"
    >
      <woot-tabs-item
        v-for="(tab, index) in tabs"
        :key="tab.key"
        :index="index"
        :name="tab.name"
        :show-badge="false"
      />
    </woot-tabs>

    <WootReports
      v-if="selectedTabIndex === 0"
      key="agent-reports"
      type="agent"
      getter-key="agents/getAgents"
      action-key="agents/get"
      :download-button-label="$t('REPORT.DOWNLOAD_AGENT_REPORTS')"
    />

    <AgentsInboxesReports v-else />
  </div>
</template>
